import React from 'react';
import { FaBed, FaBath, FaCar, FaWindowMaximize } from 'react-icons/fa';

const PropertyDetails = ({ furnishedStatus, carParking, bedrooms, bathrooms, balconies }) => {
  const details = [
    bedrooms && { icon: <FaBed className="text-gray-600" />, label: `${bedrooms} Beds` },
    balconies && { icon: <FaBed className="text-gray-600" />, label: `${balconies} Balconies` },
    bathrooms && { icon: <FaBath className="text-gray-600" />, label: `${bathrooms} Baths` },
    carParking && { icon: <FaCar className="text-gray-600" />, label: `${carParking} Covered Parking` },
    furnishedStatus && { icon: <FaWindowMaximize className="text-gray-600" />, label: furnishedStatus }
  ].filter(Boolean).slice(0, 4);

  return (
    <div className="grid grid-cols-2 gap-2 sm:gap-0 sm:flex items-center bg-[#f5f5f5] p-3 sm:p-4 rounded-lg text-xs sm:text-[14px] whitespace-nowrap truncate">
      {details.map((detail, index) => (
        <React.Fragment key={index}>
          <div className="flex items-center space-x-2">
            {detail.icon}
            <span className="text-[#303030] font-medium ">{detail.label}</span>
          </div>
          {index < details.length - 1 && <div className="border-l border-gray-300 h-6 mx-2 hidden md:block"></div>}
        </React.Fragment>
      ))}
    </div>
  );
};

export default PropertyDetails;
